/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {retryBotJob} from '../api'

export const useMutationRetryBotJob = createReactQueryMutationHook('retryBotJob', retryBotJob)
